export default {
  title: 'Content Management System',
  subtitle: 'Manage your website content, activities, stories, guiders, reviews, and settings',

  menu: {
    dashboard: 'Dashboard',
    activities: 'Activities',
    stories: 'Stories',
    guides: 'Guiders',
    team: 'Team',
    reviews: 'Reviews',
    contactMessages: 'Contact Inbox',
    faq: 'Help Center',
    pages: 'Pages',
    menus: 'Menus',
    media: 'Media Library',
    settings: 'Settings'
  },
  activities: {
    title: 'Activities',
    activityTitle: 'Activity Title',
    createNew: 'Create New Activity',
    createActivity: 'Create Activity',
    editActivity: 'Edit Activity',
    name: 'Activity Name',
    description: 'Description',
    location: 'Location',
    duration: 'Duration',
    price: 'Price',
    category: 'Category',
    status: 'Status',
    statusOptions: {
      draft: 'Draft',
      published: 'Published',
      archived: 'Archived'
    },
    categories: {
      adventure: 'Adventure',
      cultural: 'Cultural',
      nature: 'Nature',
      relaxation: 'Relaxation',
      sports: 'Sports'
    },
    emptyStateTitle: 'No activities yet',
    emptyStateHint: 'Create your first activity to start showcasing your team members.',
    searchPlaceholder: 'Search activities...',
    bsActivityLink: 'Booking System Activity Link',
    bsActivityLinkSubtitle: 'To view and edit setup and builder section of the activity click here',
    searchBsActivity: 'Search BS Activity',
    searchBsActivityPlaceholder: 'Type to search for existing activities...',
    basicInformation: 'Basic Information',
    slug: 'URL Slug',
    modality: 'Modality',
    typeOfBooking: 'Type of Booking',
    startDate: 'Start Date',
    endDate: 'End Date',
    basePrice: 'From Price (EUR)',
    basePriceSingleRoom: 'From Price in EUR (Single Room)',
    basePriceDoubleRoom: 'From Price in EUR (Double Room)',
    pricingSettings: 'Pricing Settings',
    groupSize: 'Group Size',
    difficulty: 'Difficulty',
    locationInformation: 'Location Information',
    generalLocation: 'General Location',
    generalCountry: 'General Country',
    fromLocation: 'From Location',
    toLocation: 'To Location',
    generalAccommodation: 'General Accommodation',
    travelType: 'Travel Type',
    map: 'Map Embed URL',
    mapHelp: '<p><strong>How to get Google Maps Embed URL:</strong></p><ol><li>Go to <a href="https://maps.google.com" target="_blank">Google Maps</a></li><li>Search for or navigate to the location you want</li><li>Click the <strong>"Share"</strong> button</li><li>Select the <strong>"Embed a map"</strong> tab</li><li>Copy the iframe <strong>src</strong> URL (starts with https://www.google.com/maps/embed)</li><li>Paste it here</li></ol><p><strong>Example:</strong><br>https://www.google.com/maps/embed?pb=!1m18!1m12!...</p>',
    categoriesAndLanguages: 'Categories and Languages',
    availableLanguages: 'Available Languages',
    services: 'Services',
    transfer: 'Luggage Transfer',
    transport: 'Transport',
    luggageTransport: 'Luggage Transport',
    transferService: 'Transfer',
    serviceBookingTooltip: 'When enabled, visitors can request this service via a booking popup on the website.',
    viewOnWebsite: 'View on website',
    previewOnWebsite: 'Preview on website',
    previewMissingSlug: 'Add a slug for this language before previewing.',
    previewLocaleUnsupported: 'Website preview is available for English and Dutch only. Switch language tab and try again.',
    previewMissingSiteUrl: 'Set the Site URL in CMS Settings before previewing.',
    previewUnavailable: 'Save the activity first to generate a preview link.',
    goToActivitySetup: 'Go to activity setup',
    suggestedActivities: 'Suggested activities',
    suggestedActivitiesHelp: 'Other CMS activities shown as suggestions on this activity page.',
    overviewContent: 'Overview content',
    overviewWebsiteHelp: 'Shown in: Overview on website',
    faqWebsiteHelp: 'Shown in: Things to Know',
    importFromBuilder: 'Import from Activity Builder',
    copyFromActivity: 'Copy from CMS activity',
    copyFromActivityTitle: 'Copy content from another activity',
    copyFromActivityHelp: 'Select which sections to copy from the chosen CMS activity.',
    copySections: {
      translations: 'Translations & SEO',
      configuration: 'Configuration',
      stages: 'Itinerary stages',
      overview: 'Overview content',
      faq: 'FAQ (Things to Know)',
      categories: 'Categories',
      suggestedActivities: 'Suggested activities',
    },
    applyCopy: 'Apply copy',
    stageFrom: 'From',
    stageTo: 'To',
    stageMode: 'Travel mode',
    stageDistance: 'Distance (km)',
    stageLocation: 'Location',
    isStageDay: 'Stage day (route segment)',
    stageModeWalk: 'Walk',
    stageModeBike: 'Bike',
    stagesHelp: 'Edit daily itinerary stages for the website. Stages are initially populated from the BS activity but can be customized.',
    addDay: 'Add day',
    reorderDay: 'Drag to reorder',
    stageDayLabel: 'Day {order}',
    stageDayCountOne: '{count} day',
    stageDayCountMany: '{count} days',
    addFirstDay: 'Add first day',
    noStagesYet: 'No itinerary days yet',
    noStagesHint: 'Import from the Activity Builder or add days manually.',
    stageTitlePlaceholder: 'Day title',
    stageImage: 'Day image',
    stageImageHelp: 'Featured image shown for this itinerary day on the website.',
    stageFeaturedImageAltHelp: 'HTML alt attribute for accessibility and SEO. It is not shown as a caption under the image. If left empty, the day title is used.',
    stageDescription: 'Day description',
    stageRouteHint: 'Route segment with from/to locations, travel mode, and distance.',
    stageLocationHint: 'Free-text location for non-route days (rest days, transfers, etc.).',
    expandAllDays: 'Expand all',
    collapseAllDays: 'Collapse all',
    stagesTotalDistance: '{distance} km total',
    stageContentSection: 'Content',
    stageRouteSection: 'Route & location',
    dayTypeRoute: 'Route',
    dayTypeLocation: 'Location',
    overviewWhyChoose: 'Why choose this trip',
    overviewHighlights: 'Highlights',
    overviewSuitability: 'Suitability',
    overviewConsiderations: 'Considerations',
    overviewSectionLabel: 'Section label',
    overviewTitle: 'Title',
    overviewSubLabel: 'Sub-label',
    overviewListItems: 'List items',
    addListItem: 'Add item',
    content: 'Content',
    aboutThisTrip: 'About This Trip',
    additionalInfo: 'Additional Information',
    extraInformation: 'Extra Information',
    includesInformation: 'Includes Information',
    includedInformation: 'Included Information',
    notIncludedInformation: 'Not Included Information',
    addIncludedItem: 'Enter included item...',
    addNotIncludedItem: 'Enter not included item...',
    addItem: 'Add Item',
    guiders: 'Guiders',
    guiderName: 'Guider Name',
    guidersHelp: 'Select guiders to associate with this activity. Create new guiders in the Guiders section.',
    guiderTagline: 'Tagline',
    sinceDate: 'Since Year',
    rating: 'Rating',
    numberOfReviews: 'Number of Reviews',
    addGuider: 'Add Guider',
    reviews: 'Reviews',
    reviewTitle: 'Review Title',
    reviewerName: 'Reviewer Name',
    reviewDate: 'Review Date',
    reviewContent: 'Review Content',
    addReview: 'Add Review',
    stages: 'Stages',
    stage: 'Stage',
    stageOrder: 'Stage Order',
    stageTitle: 'Stage Title',
    stageDescription: 'Stage Description (WYSIWYG)',
    stageFeaturedImage: 'Stage Featured Image',
    stageGallery: 'Stage Gallery URLs',
    stageExtraData: 'Stage Extra Data',
    addExtraDataItem: 'Enter extra data item...',
    addStage: 'Add Stage',
    faq: 'FAQ',
    faqQuestion: 'Question',
    faqAnswer: 'Answer (WYSIWYG)',
    addFaqItem: 'Add FAQ Item',
    noFaqsYet: 'No FAQs added yet',
    addFirstFaqHint: 'Click the button below to add your first FAQ',
    faqQuestionPlaceholder: 'Enter your question here...',
    media: 'Media',
    featuredImage: 'Featured Image URL',
    gallery: 'Gallery URLs',
    addImage: 'Add Image',
    seo: 'SEO',
    seoTitle: 'SEO Title',
    seoDescription: 'SEO Description',
    keywords: 'Keywords',
    addKeyword: 'Add Keyword',
    keywordsHelp: 'Optional SEO terms for this language. Empty rows are ignored when you save.',
    titlePlaceholder: 'Add title here...',
    publish: 'Publish',
    visibility: 'Visibility',
    visibilityPublic: 'Visible to everyone',
    visibilityPrivate: 'Only visible to site admins',
    details: 'Details',
    dates: 'Dates',
    searchGuiders: 'Search Guiders',
    searchGuidersPlaceholder: 'Type to search for guiders...',
    searchReviews: 'Search Reviews',
    searchReviewsPlaceholder: 'Type to search for reviews...',
    faqNote: 'If no FAQ is provided, the default FAQ will be shown on the activity page.',
    retrievedActivity: 'Retrieve Activity',
    configuration: 'Activity Configuration',
    additionalCategories: 'Additional Categories',
    translations: 'Translations',
    isFeatured: 'Featured Activity',
    cmsFields: 'CMS Activity Fields',
    createNewGuider: 'Create New Guider',
    createNewReview: 'Create New Review',
    noGuidersAssociated: 'No guiders associated with this activity',
    noReviewsAssociated: 'No reviews associated with this activity',
    publishActivity: 'Publish',
    unpublishActivity: 'Unpublish',
    publishSuccess: 'Activity published successfully',
    unpublishSuccess: 'Activity moved to draft',
    deleteSuccess: 'CMS activity deleted successfully',
    mediaUploadRequiresCreation: 'Save the CMS activity before uploading media.',
    saveFeaturedMediaButton: 'Save Featured Image',
    featuredImageAlt: 'Featured image alt text',
    featuredImageAltHelp: 'Describe the image for accessibility and SEO.',
    saveGalleryMediaButton: 'Save Gallery',
    featuredMediaSaveSuccess: 'Featured image updated successfully.',
    galleryMediaSaveSuccess: 'Gallery updated successfully.',
    translationValidationError: 'Please complete {fields} for {language}.',
    translationGenericLanguage: 'this language',
    featuredBadge: 'Featured',
    cmsActivityLabel: 'CMS Activity',
    addToCmsActivity: 'Add to CMS',
    cmsActivityPublished: 'Published',
    cmsActivityDraft: 'Draft',
    noCategoriesAvailable: 'No categories available',
    addCategoryHint: 'Use the Add button to open the category manager and create one.',
    additionalCategoriesHelp: 'Choose which categories apply to this activity. Names follow the language selected in your translation tab.',
    categoriesSelectedSummary: '{count} selected',
    retrieveActivityNote: 'Select an activity from the BS to relate with the website activity. This will automatically fill some important information.',
    loadingActivityDetails: 'Loading activity details...',
    cmsFieldsPlaceholderTitle: 'Select an activity above to start customizing content, SEO settings, and translations for your website.',
    multiLanguageContent: 'Multi-language content',
    seoOptimization: 'SEO optimization',
    keywordsMetadata: 'Keywords & metadata',
    activityModalityHelp: 'Activity modality',
    durationPlaceholder: 'e.g., 6 Days',
    durationHelp: 'Duration of the activity (editable)',
    accommodationPlaceholder: 'e.g., 3-star hotels',
    basePriceSingleRoomHelp: 'From price for single room (EUR)',
    basePriceDoubleRoomHelp: 'From price for double room (EUR)',
    startDateHelp: 'Start date for the activity (required for group modality)',
    groupTripDateRanges: 'Group trip dates',
    tripRangeLabel: 'Trip {n}',
    tripRangeColTrip: '#',
    tripRangeColSingle: 'Single €',
    tripRangeColDouble: 'Double €',
    tripRangeColMaxPax: 'Max pax',
    tripRangeColAvailable: 'Avail.',
    tripRangeAvailableHint: 'Available spots (max minus booked)',
    tripRangeMaxPax: 'Max participants',
    tripRangeColGuiders: 'Guides',
    groupTripDateRangesHelp:
      'Add one departure per row. New trips use the activity base prices above; override per departure if needed. Set max participants per trip for website availability. End date is calculated from activity duration.',
    tripRangeStart: 'Start',
    tripRangeEnd: 'End (auto)',
    tripRangeEndAutoHelp: 'Calculated from activity duration ({days} days).',
    tripRangeEndAutoNoDuration: 'Set activity duration above to auto-calculate the end date.',
    tripRangeGuiders: 'Guides for this trip',
    removeTripDates: 'Remove this trip',
    addTripDates: 'Add trip dates',
    basePriceHelp: 'From price for this activity (EUR)',
    configurationPlaceholderDescription: 'Configure activity settings like pricing, difficulty, booking type, and more once you select an activity.',
    pricingBooking: 'Pricing & booking',
    locationDetails: 'Location details',
    durationDates: 'Duration & dates',
    stagesReadOnlyNote: '⚠️ Daily itinerary stages from the retrieved activity (Read-only)',
    stagesNotAvailable: '🚧 Stages data is not available yet',
    stagesWipMessage: 'This section is Work In Progress. The endpoint to retrieve stages from the BS activity is being implemented by the backend developer.',
    dayStage: 'Day {order}: {title}',
    stagesPlaceholderNote: 'Daily itinerary stages will appear here',
    stagesPlaceholderDescription: 'View and manage the daily itinerary stages that will be automatically imported from your selected activity.',
    dayByDaySchedule: 'Day-by-day schedule',
    routeInformation: 'Route information',
    readOnlyContent: 'Read-only content',
    reviewsPlaceholderDescription: 'Showcase customer testimonials and reviews to build credibility and help potential customers make decisions.',
    starRatings: 'Star ratings',
    customerStories: 'Customer stories',
    socialProof: 'Social proof',
    associatedReviewsNote: 'Associated reviews from the Reviews section',
    createReviewsHint: 'Create reviews in the Reviews section to associate them with this activity',
    faqPlaceholderDescription: 'Add frequently asked questions to help visitors understand your activity better.',
    commonQuestions: 'Common questions',
    quickAnswers: 'Quick answers',
    customerSupport: 'Customer support',
    mediaPlaceholderDescription: 'Upload images to showcase your activity. Featured image will be displayed prominently.',
    highQualityImages: 'High-quality images',
    gallerySupport: 'Gallery support',
    visualAppeal: 'Visual appeal',
    recommendedSize: 'Recommended: 1920x1080px',
    galleryHelpText: 'Add multiple images to your activity gallery',
    pleaseSelectActivityFirst: 'Please select an activity first',
    cmsActivityUpdatedSuccess: 'CMS Activity updated successfully',
    cmsActivityCreatedSuccess: 'CMS Activity created successfully',
    errorSavingCmsActivity: 'Error saving CMS activity. Please try again.',
    noActivitySelected: 'No activity selected',
    draftSavedSuccess: 'Draft saved successfully',
    activityPublishedSuccess: 'Activity published successfully',
    noUploadsToConfirm: 'No uploads to confirm',
    modalityOptions: {
      selfGuided: 'Self-Guided',
      group: 'Group',
    },
    bookingTypeOptions: {
      enquiry: 'Enquiry',
      booking: 'Booking',
      instant: 'Instant',
      hybrid: 'Hybrid',
    },
    difficultyOptions: {
      easy: 'Easy',
      medium: 'Medium',
      intermediate: 'Intermediate',
      hard: 'Hard',
    },
    languageOptions: {
      en: 'English',
      es: 'Spanish',
      nl: 'Dutch',
    },
  },
  stories: {
    title: 'Stories',
    createNew: 'Create New Story',
    createStory: 'Create Story',
    editStory: 'Edit Story',
    publishing: 'Publish settings',
    generalInfo: 'General Information',
    translationsSection: 'Content',
    seoSection: 'SEO',
    mediaSection: 'Media',
    relationshipsSection: 'Relationships',
    storyTitle: 'Title',
    author: 'Author (team member)',
    authorPlaceholder: 'Select a team member',
    category: 'Category',
    categoryPlaceholder: 'Select a category',
    content: 'Content',
    contentShortcodeHelp: 'Insert [waw_newsletter] anywhere in the content to embed the newsletter signup form on the website at that position.',
    insertNewsletterShortcode: 'Insert newsletter form',
    excerpt: 'Excerpt',
    featuredImage: 'Featured Image',
    featuredImageHelp: 'Recommended size: 1920x1080px',
    featuredImageAlt: 'Featured image alt text',
    featuredImageAltHelp: 'Describe the image for accessibility and SEO.',
    tags: 'Tags',
    tagsPlaceholder: 'Add a tag',
    publishDate: 'Publish Date',
    scheduledPublish: 'Schedule publication',
    publishedAt: 'Published At',
    status: 'Status',
    isFeatured: 'Featured Story',
    isPublic: 'Public Story',
    relatedActivities: 'Related Activities',
    relatedActivitiesHelp: 'Link this story to CMS activities to display them as related experiences.',
    faqNote: 'Optional. Add FAQs that will be shown on the story page.',
    noFaqsYet: 'No FAQs yet',
    addFirstFaqHint: 'Click "Add FAQ" to add your first question and answer.',
    statusOptions: {
      draft: 'Draft',
      published: 'Published',
      scheduled: 'Scheduled'
    },
    filters: {
      language: 'Language',
      status: 'Status',
      category: 'Category',
      author: 'Author',
      tag: 'Tag',
      featured: 'Featured only',
      public: 'Public only'
    },
    list: {
      emptyStateTitle: 'No stories yet',
      emptyStateHint: 'Create your first story to start sharing travel inspiration.'
    },
    searchPlaceholder: 'Search stories...',
    slug: 'Slug',
    customUrl: 'Custom URL',
    customUrlHelp: 'The URL slug for this story (e.g., "my-story", "travel-tips"). Leave empty to use the translation slug.',
    seoTitle: 'SEO Title',
    seoDescription: 'SEO Description',
    seoKeywords: 'SEO Keywords',
    seoKeywordsPlaceholder: 'Add keyword',
    media: 'Media',
    gallery: 'Gallery',
    galleryHelp: 'Add up to 20 images to showcase this story.',
    uploadFeatured: 'Save Featured Image',
    uploadGallery: 'Save Gallery',
    tagsHelper: 'Use meaningful keywords to help SEO',
    translations: 'Translations',
    translationValidationError: 'Please complete {fields} for {language}.',
    translationGenericLanguage: 'this language',
    relatedActivitiesPlaceholder: 'Search CMS activities...',
    publishSuccess: 'Story published successfully',
    unpublishSuccess: 'Story moved to draft status',
    deleteSuccess: 'Story deleted successfully'
  },
  guides: {
    title: 'Guiders',
    createNew: 'Create New Guider',
    createGuide: 'Create Guider',
    editGuide: 'Edit Guider',
    userSelection: 'User Selection',
    user: 'User',
    userPlaceholder: 'Select a user (optional)',
    generalInfo: 'General Information',
    additionalInfo: 'Additional Information',
    relationshipsSection: 'Relationships',
    guideTitle: 'Title',
    slug: 'Slug',
    bio: 'Bio',
    tagline: 'Tagline',
    content: 'Content',
    memberSince: 'Member Since',
    memberSinceHelp: 'Date when the guider became a member',
    relatedActivities: 'Related Activities',
    relatedActivitiesHelp: 'Link this guider to CMS activities to display them as related experiences.',
    relatedActivitiesPlaceholder: 'Search CMS activities...',
    mediaSection: 'Media',
    featuredImage: 'Featured Image',
    featuredImageHelp: 'Recommended size: 1920x1080px',
    featuredImageAlt: 'Featured image alt text',
    featuredImageAltHelp: 'Describe the image for accessibility and SEO.',
    uploadFeatured: 'Save Featured Image',
    publishing: 'Publishing',
    isPublic: 'Public',
    isFeatured: 'Featured',
    isAuthor: 'Author',
    seoTitle: 'SEO Title',
    seoDescription: 'SEO Description',
    seoKeywords: 'SEO Keywords',
    seoKeywordsPlaceholder: 'Add keywords...',
    description: 'Description',
    destination: 'Destination',
    category: 'Category',
    difficulty: 'Difficulty Level',
    duration: 'Estimated Duration',
    status: 'Status',
    statusOptions: {
      draft: 'Draft',
      published: 'Published',
      archived: 'Archived'
    },
    difficultyLevels: {
      easy: 'Easy',
      moderate: 'Moderate',
      difficult: 'Difficult',
      expert: 'Expert'
    },
    searchPlaceholder: 'Search guiders...',
    filters: {
      language: 'Language'
    },
    list: {
      emptyStateTitle: 'No guiders yet',
      emptyStateHint: 'Create your first guider to start showcasing your team members.'
    },
    publishSuccess: 'Guider published successfully',
    unpublishSuccess: 'Guider moved to draft status',
    deleteSuccess: 'Guider deleted successfully'
  },
  team: {
    title: 'Team',
    createNew: 'Create Team Member',
    createMember: 'Create Team Member',
    editMember: 'Edit Team Member',
    generalInfo: 'General Information',
    translationsSection: 'Translations',
    name: 'Name',
    role: 'Role',
    bio: 'Bio',
    facts: 'Fun facts',
    factQuestion: 'Question',
    factAnswer: 'Answer',
    addFact: 'Add fact',
    order: 'Order',
    orderHelp: 'Lower numbers appear first on the about page',
    linkedGuider: 'Linked guider (optional)',
    linkedGuiderPlaceholder: 'Select a guider profile',
    linkedin: 'LinkedIn profile URL',
    linkedinPlaceholder: 'https://www.linkedin.com/in/username',
    instagram: 'Instagram profile URL',
    instagramPlaceholder: 'https://www.instagram.com/username',
    noLinkedGuider: 'None',
    mediaSection: 'Media',
    featuredImage: 'Photo',
    featuredImageHelp: 'Recommended size: 800x1000px or similar portrait ratio',
    featuredImageAlt: 'Photo alt text',
    uploadFeatured: 'Save Photo',
    publishing: 'Publishing',
    isPublic: 'Public',
    searchPlaceholder: 'Search team members...',
    translationValidationError: 'Please provide at least one complete translation (name and bio).',
    filters: {
      language: 'Language'
    },
    list: {
      emptyStateTitle: 'No team members yet',
      emptyStateHint: 'Add team members to display them on the about page.'
    },
    publishSuccess: 'Team member published successfully',
    unpublishSuccess: 'Team member moved to draft',
    deleteSuccess: 'Team member deleted successfully'
  },
  reviews: {
    title: 'Reviews',
    createNew: 'Create New Review',
    createReview: 'Create Review',
    editReview: 'Edit Review',
    generalInfo: 'General Information',
    additionalInfo: 'Additional Information',
    relationshipsSection: 'Relationships',
    mediaSection: 'Media',
    reviewTitle: 'Title',
    author: 'Author Name',
    authorName: 'Author Name',
    authorEmail: 'Author Email',
    rating: 'Rating',
    content: 'Review Content',
    activity: 'Related Activity',
    activityPlaceholder: 'Select an activity (optional)',
    activityHelp: 'Leave empty for general reviews, or select an activity to associate this review.',
    date: 'Review Date',
    status: 'Status',
    statusOptions: {
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected'
    },
    statuses: {
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected'
    },
    approve: 'Approve Review',
    reject: 'Reject Review',
    statusUpdateSuccess: 'Review status updated successfully',
    ratings: {
      1: '1 Star',
      2: '2 Stars',
      3: '3 Stars',
      4: '4 Stars',
      5: '5 Stars'
    },
    featuredImage: 'Featured Image',
    featuredImageHelp: 'Recommended size: 1920x1080px',
    featuredImageAlt: 'Featured image alt text',
    featuredImageAltHelp: 'Describe the image for accessibility and SEO.',
    uploadFeatured: 'Save Featured Image',
    searchPlaceholder: 'Search reviews...',
    filters: {
      language: 'Language',
      activity: 'Activity',
      rating: 'Rating',
      status: 'Status'
    },
    list: {
      emptyStateTitle: 'No reviews yet',
      emptyStateHint: 'Create your first review to start collecting feedback.'
    },
    publishSuccess: 'Review published successfully',
    unpublishSuccess: 'Review moved to draft status',
    deleteSuccess: 'Review deleted successfully'
  },
  contactMessages: {
    title: 'Contact Inbox',
    subtitle: 'Messages submitted via the website contact form.',
    searchPlaceholder: 'Search by name, email or message…',
    topic: 'Topic',
    message: 'Message',
    from: 'From',
    locale: 'Language',
    receivedAt: 'Received',
    reference: 'Reference',
    viewMessage: 'View message',
    markRead: 'Mark as read',
    markNew: 'Mark as unread',
    archive: 'Archive',
    restore: 'Restore to inbox',
    replyViaEmail: 'Reply via email',
    statusUpdateSuccess: 'Message status updated',
    deleteSuccess: 'Message deleted successfully',
    selectTitle: 'Select a message',
    selectHint: 'Choose a message from the list to read and reply.',
    messageCount: '{count} messages',
    topics: {
      booking: 'Booking or payment',
      trip: 'Question about a trip',
      custom: 'Custom or private trip',
      other: 'Something else',
      general: 'General'
    },
    statuses: {
      new: 'New',
      read: 'Read',
      archived: 'Archived'
    },
    filters: {
      status: 'Status',
      topic: 'Topic'
    },
    list: {
      emptyStateTitle: 'No contact messages yet',
      emptyStateHint: 'Submissions from the website contact form will appear here.'
    }
  },
  faq: {
    title: 'Help Center',
    createNew: 'Create New Article',
    createFaq: 'Create Article',
    editFaq: 'Edit Article',
    createCategory: 'Create Category',
    articleTitle: 'Article Title',
    generalInfo: 'General Information',
    contentSection: 'Content',
    faqSection: 'FAQ Items',
    question: 'Question',
    answer: 'Answer',
    category: 'Category',
    addFaqItem: 'Add FAQ Item',
    addFaqToCategory: 'Add FAQ to Category',
    manageFaqs: 'Manage FAQs',
    removeFaqItem: 'Remove FAQ Item',
    order: 'Display Order',
    status: 'Status',
    categoryName: 'Category Name',
    categorySlug: 'Category Slug',
    categoryDescription: 'Category Description',
    editCategory: 'Edit Category',
    selectCategory: 'Select Category',
    statusOptions: {
      draft: 'Draft',
      published: 'Published',
      archived: 'Archived'
    },
    categories: {
      general: 'General',
      booking: 'Booking',
      travel: 'Travel',
      activities: 'Activities',
      payment: 'Payment'
    },
    searchPlaceholder: 'Search articles...',
    filters: {
      language: 'Language',
      category: 'Category'
    },
    list: {
      emptyStateTitle: 'No articles yet',
      emptyStateHint: 'Create your first help center article to start helping your users.'
    },
    publishSuccess: 'Article published successfully',
    unpublishSuccess: 'Article moved to draft status',
    deleteSuccess: 'Category deleted successfully',
    faq: 'FAQ',
    faqs: 'FAQs'
  },
  settings: {
    title: 'Settings',
    save: 'Save Settings',
    general: {
      title: 'General Settings',
      siteName: 'Site Name',
      siteDescription: 'Site Description',
      siteUrl: 'Site URL',
      siteNamePlaceholder: 'Enter site name',
      siteDescriptionPlaceholder: 'Enter a brief description of your site',
      siteUrlPlaceholder: 'https://example.com',
    },
    contact: {
      title: 'Contact Information',
      email: 'Contact Email',
      phone: 'Contact Phone',
      address: 'Address',
      city: 'City',
      postalCode: 'Postal Code',
      country: 'Country',
      emailPlaceholder: "contact{'@'}example.com",
      phonePlaceholder: '+1 234 567 8900',
      addressPlaceholder: 'Street address',
      cityPlaceholder: 'City',
      postalCodePlaceholder: 'Postal code',
      countryPlaceholder: 'Country',
    },
    social: {
      title: 'Social Media Links',
      facebook: 'Facebook URL',
      instagram: 'Instagram URL',
      twitter: 'Twitter URL',
      linkedin: 'LinkedIn URL',
      youtube: 'YouTube URL',
      facebookPlaceholder: 'https://facebook.com/yourpage',
      instagramPlaceholder: 'https://instagram.com/yourpage',
      twitterPlaceholder: 'https://twitter.com/yourpage',
      linkedinPlaceholder: 'https://linkedin.com/company/yourpage',
      youtubePlaceholder: 'https://youtube.com/channel/yourchannel',
    },
    hero: {
      title: 'Hero Media',
      mediaType: 'Media type',
      none: 'No media',
      image: 'Image',
      video: 'Uploaded video',
      youtube: 'YouTube video',
      youtubeUrl: 'YouTube URL',
      imageUpload: 'Hero image',
      videoUpload: 'Hero video',
      videoRecommendedSpec: 'Recommended: 1920x1080 (16:9), 6-15s loop, MP4 H.264, 1.5-4 MB.',
      videoMobileImageHint:
        'On mobile and narrow screens (768px and below), the website shows the hero image instead of the video. Upload a fallback image below for mobile visitors.',
      mobileImageUpload: 'Mobile hero image (fallback)',
      textMode: 'Text visibility mode',
      textModeAuto: 'Automatic readability',
      textModeManual: 'Manual control',
      textVisible: 'Show hero text (manual mode)',
      overlayEnabled: 'Enable dark overlay',
      overlayOpacity: 'Overlay opacity (0-100)',
    },
    appearance: {
      title: 'Appearance',
      primaryColor: 'Primary Color',
      secondaryColor: 'Secondary Color',
      logo: 'Logo',
      uploadLogo: 'Upload Logo',
      changeLogo: 'Change Logo',
      favicon: 'Favicon',
      changeFavicon: 'Change Favicon',
      defaultLogo: 'Default logo will be used if not uploaded',
      defaultFavicon: 'Default favicon will be used if not uploaded',
      defaultAppearance: 'Default appearance settings will be used if not configured',
      uploaded: 'Uploaded',
      primaryColorPlaceholder: '#667eea',
      secondaryColorPlaceholder: '#764ba2',
    },
    tripAvailability: {
      title: 'Trip availability messages',
      threshold: 'Low-stock threshold',
      thresholdHelp: 'Show the urgency message when this many spots or fewer remain.',
      lowStockEn: 'Low-stock message (English)',
      lowStockNl: 'Low-stock message (Dutch)',
      soldOutEn: 'Sold-out message (English)',
      soldOutNl: 'Sold-out message (Dutch)',
      unavailableEn: 'Not enough spots message (English)',
      unavailableNl: 'Not enough spots message (Dutch)',
      placeholderCount: 'Use {count} for remaining spots',
    },
    maintenance: {
      title: 'Maintenance',
      enabled: 'Enable maintenance mode on the public website',
      statusOn: 'Maintenance is ON',
      statusOff: 'Maintenance is OFF',
      warning:
        'When enabled, visitors only see the under-construction page. Search engines receive 503 and robots.txt blocks crawling.',
      titleEn: 'Headline (English)',
      titleNl: 'Headline (Dutch)',
      messageEn: 'Message (English)',
      messageNl: 'Message (Dutch)',
      bypassTitle: 'Preview bypass',
      bypassHint:
        'Use ?maintenance_bypass=TOKEN on the website to preview the live site while maintenance stays on for everyone else.',
      bypassToken: 'Bypass token',
      copyToken: 'Copy',
      regenerateToken: 'Regenerate',
      envHint:
        'Also set MAINTENANCE_BYPASS_TOKEN on the website server to the same value so the bypass works.',
      noToken: 'No bypass token available yet. Save settings or regenerate one.',
      tokenCopied: 'Bypass token copied',
      tokenRegenerated: 'Bypass token regenerated',
      previewWebsite: 'Preview website',
      regenerateConfirmTitle: 'Regenerate bypass token?',
      regenerateConfirmMessage:
        'This will send your current token to a nice farm upstate. You will also need to update MAINTENANCE_BYPASS_TOKEN in your website env — unless you enjoy surprise lockouts. Was that click intentional?',
      regenerateConfirmButton: 'Yes, regenerate it',
      regenerateCancelButton: 'Never mind, I like my token',
    },
  },
  dashboard: {
    title: 'Dashboard',
    subtitle: 'Overview of your CMS content',
    quickGoto: 'Quick go to',
    quickGotoHint: 'Jump straight into the sections you use most.',
    greetingMorning: 'Good morning',
    greetingAfternoon: 'Good afternoon',
    greetingEvening: 'Good evening',
    heroSummary: 'You currently manage {count} content items across the site.',
    publishRate: 'Live',
    contentMix: 'Content mix',
    contentMixHint: 'Share of your catalog by section, ranked largest first.',
    healthTitle: 'Live coverage',
    healthHint: 'How much of each section is already public.',
    liveOfTotal: '{live} of {total} live',
    items: 'Items',
    people: 'People',
    attention: {
      maintenanceTitle: 'Maintenance mode is on',
      maintenanceMeta: 'Public visitors see the construction page. Manage settings.',
      reviewsTitle: '{count} reviews waiting',
      reviewsMeta: 'Approve or reject pending visitor reviews.',
      inboxTitle: '{count} new messages',
      inboxMeta: 'Open the contact inbox to reply.',
    },
    stats: {
      activities: 'Activities',
      stories: 'Stories',
      pages: 'Pages',
      reviews: 'Reviews',
      contactMessages: 'Contact messages',
      guiders: 'Guiders',
      teamMembers: 'Team members',
      public: 'Public',
      pending: 'Pending',
      new: 'New',
    },
    maintenance: {
      title: 'Website maintenance',
      on: 'On',
      off: 'Off',
      manage: 'Manage',
    },
  },
  pages: {
    title: 'Pages',
    createNew: 'Create New Page',
    createPage: 'Create Page',
    editPage: 'Edit Page',
    status: 'Status',
    pageType: 'Page Type',
    customUrl: 'Custom URL',
    customUrlHelp: 'The URL slug for this language (e.g., "about-us", "over-ons"). Each language can have its own URL.',
    pageTypeOptions: {
      custom: 'Custom',
      about: 'About Us',
      terms: 'Terms & Conditions',
      privacy: 'Privacy Policy'
    },
    statusOptions: {
      draft: 'Draft',
      published: 'Published'
    },
    searchPlaceholder: 'Search pages...',
    filters: {
      public: 'Public Only'
    },
    list: {
      emptyStateTitle: 'No pages yet',
      emptyStateHint: 'Create your first page to start building your website content.'
    },
    publishSuccess: 'Page published successfully',
    unpublishSuccess: 'Page moved to draft status',
    deleteSuccess: 'Page deleted successfully',
    isFeatured: 'Featured Page',
    translationsSection: 'Translations',
    pageTitle: 'Page Title',
    content: 'Content',
    seoTitle: 'SEO Title',
    seoDescription: 'SEO Description',
    seoKeywords: 'SEO Keywords',
    seoKeywordsPlaceholder: 'Add keyword',
    generalInfo: 'General Information',
    order: 'Order',
    orderHelp: 'Display order for sorting',
    relationshipsSection: 'Relationships',
    relatedActivities: 'Related Activities',
    relatedActivitiesHelp: 'Link CMS activities to display on this page',
    relatedActivitiesPlaceholder: 'Search CMS activities...',
    mediaSection: 'Media',
    featuredImage: 'Featured Image',
    featuredImageHelp: 'Recommended size: 1920x1080px',
    featuredImageAlt: 'Featured image alt text',
    featuredImageAltHelp: 'Describe the image for accessibility and SEO.',
    uploadFeatured: 'Save Featured Image'
  },
  menus: {
    title: 'Menus',
    createNew: 'Create New Menu Item',
    createMenu: 'Create Menu Item',
    editMenu: 'Edit Menu Item',
    generalInfo: 'General Information',
    publishing: 'Publishing',
    menuLabel: 'Menu Label',
    menuType: 'Menu Type',
    menuTypeOptions: {
      page: 'Page',
      link: 'External Link',
      category: 'Category',
      activity: 'Activity'
    },
    parentMenu: 'Parent Menu',
    parentMenuPlaceholder: 'Select parent menu (optional)',
    parentMenuHelp: 'Leave empty for top-level menu items',
    pageLink: 'Page',
    pageLinkPlaceholder: 'Select a page',
    activityLink: 'Activity',
    activityLinkPlaceholder: 'Select an activity',
    activityRequired: 'Please select an activity',
    externalUrl: 'External URL',
    externalUrlPlaceholder: 'https://example.com',
    categorySlug: 'Category Slug',
    categorySlugPlaceholder: 'category-slug',
    order: 'Order',
    orderHelp: 'Display order in menu',
    status: 'Status',
    statusOptions: {
      draft: 'Draft',
      published: 'Published'
    },
    searchPlaceholder: 'Search menu items...',
    filters: {
      public: 'Public Only'
    },
    list: {
      emptyStateTitle: 'No menu items yet',
      emptyStateHint: 'Create your first menu item to start building your navigation.'
    },
    publishSuccess: 'Menu item published successfully',
    unpublishSuccess: 'Menu item moved to draft status',
    deleteSuccess: 'Menu item deleted successfully',
    reorderSuccess: 'Menu items reordered successfully',
    failedToLoadActivities: 'Failed to load activities',
    noActivitiesFound: 'No activities found',
    translationsSection: 'Translations',
    menuLabelHelp: 'The text displayed in the menu',
    translationValidationError: 'Please complete all required fields',
    pageRequired: 'Please select a page',
    externalUrlRequired: 'Please enter an external URL',
    categorySlugRequired: 'Please enter a category slug',
    expandAll: 'Expand All',
    collapseAll: 'Collapse All',
  },
  activityCategories: {
    title: 'Activity Categories',
    addNew: 'Add New Category',
    existingCategories: 'Existing Categories',
    noCategories: 'No categories found. Create your first category above.',
    manageCategories: 'Manage Categories',
    slug: 'Slug',
    slugPlaceholder: 'e.g., walking, biking, hiking',
    name: 'Name',
    order: 'Order',
    icon: 'Icon',
    uploadIcon: 'Upload Icon',
    iconHelp: 'Upload an SVG icon for this category (recommended: 48x48px)',
    isPublic: 'Public',
    createSuccess: 'Category created successfully',
    updateSuccess: 'Category updated successfully',
    deleteSuccess: 'Category deleted successfully',
    editCategory: 'Edit Category',
    reset: 'Reset'
  },
  storyCategories: {
    title: 'Story Categories',
    addNew: 'Add New Category',
    existingCategories: 'Existing Categories',
    noCategories: 'No categories found. Create your first category above.',
    type: 'Type',
    types: {
      destination: 'Destination',
      topic: 'Topic'
    },
    parent: 'Parent Category',
    rootCategory: '— Root (no parent)',
    slug: 'Slug',
    slugPlaceholder: 'e.g., camino-frances, mallorca',
    name: 'Name',
    order: 'Order',
    isPublic: 'Public',
    editCategory: 'Edit Category',
    createSuccess: 'Category created successfully',
    updateSuccess: 'Category updated successfully',
    deleteSuccess: 'Category deleted successfully',
    reset: 'Reset'
  },
  media: {
    title: 'Media Library',
    subtitle: 'Upload and manage images, videos, and documents for use across your site.',
    upload: 'Upload Media',
    filterByType: 'Filter by Type',
    search: 'Search',
    searchPlaceholder: 'Search media by name...',
    types: {
      image: 'Image',
      video: 'Video',
      document: 'Document'
    },
    emptyState: 'No media found. Upload your first file to get started.',
    selectFromLibrary: 'Select from Library',
    chooseFromLibrary: 'Choose from Library',
    or: 'or',
    uploadMedia: 'Upload Media',
    copyUrl: 'Copy URL',
    copyUrlSuccess: 'URL copied to clipboard',
    copyUrlFailed: 'Could not copy URL to clipboard',
    download: 'Download',
    downloading: 'Downloading…',
    downloadFailed: 'Could not download this file',
    moreActions: 'More actions',
    preview: 'Preview',
    previewTitle: 'Media preview',
    openInNewTab: 'Open in new tab',
    typeLabel: 'Type',
    sizeLabel: 'Size',
    dateLabel: 'Uploaded',
    clickToPreview: 'Click to preview',
    uploadSuccess: 'Media uploaded successfully',
    uploadFailed: 'Failed to upload media',
    uploadHint: 'Select files to upload. They are only added to your library when you click Save to library.',
    noFilesToSave: 'Add at least one file before saving to the library.',
    finishUpload: 'Save to library',
    agencyNotFound: 'Agency not found',
    loadFailed: 'Failed to load media',
    settingsNotLoaded: 'Could not load CMS settings required for upload'
  }
}; 